import React, { Component } from 'react';
import './address.css';
import { AppCollapsible } from '../AppCollapsible';
import { INPUT_TYPES } from '../../../config/constants';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { AppInputWrapper } from '../AppInputWrapper';


const ADDRESS_TYPES = {
    SHORT: 'short',
    LONG: 'long'
}

class Address extends Component {

    state = {
        addressType: this.props.initialValues.type === INPUT_TYPES.SHORT_ADDRESS ? ADDRESS_TYPES.SHORT : ADDRESS_TYPES.LONG,
        required: this.props.initialValues.isRequired || false,
        label: this.props.initialValues.label || 'What\'s your address',
        shortAddressValue: '',
        longAddressValue: {
            'Address line 1': '',
            'Address line 2': '',
            'Town/City': '',
            'Postcode/Zip Code': '',
            'Country': ''
        },
        requiredError: !!this.props.initialValues.isRequired,
    }

    updateInputPropsInStore = () => {
        const { label, required, addressType, shortAddressValue, longAddressValue, requiredError } = this.state;
        const inputProps = {
            label,
            isRequired: required,
            type: addressType === ADDRESS_TYPES.SHORT ? INPUT_TYPES.SHORT_ADDRESS : INPUT_TYPES.LONG_ADDRESS,
            _value: addressType === ADDRESS_TYPES.SHORT ? shortAddressValue : longAddressValue,
            _hasValidationErrors: requiredError,
        };

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);
    }

    componentDidUpdate() {
        this.updateInputPropsInStore();
    }

    setAddressType = (e) => {
        let addressType = e.target.value;
        this.setState({ addressType: addressType })
    }

    setRequired = (e) => {
        this.setState({ required: e.target.checked })
    }

    setLabel = (e) => {
        this.setState({ label: e.target.value })
    }

    setShortAddressValue = (e) => {
        this.setState({
            shortAddressValue: e.target.value,
            requiredError: this.state.required ? !e.target.value : false
        });
    }

    setLongAddressValue = (target, e) => {
        const curVal = { ...this.state.longAddressValue, [target]: e.target.value };
        let hasEmptyValues = false;
        Object.values(curVal).forEach(val => {
            if (!val) {
                hasEmptyValues = true;
            }
        })
        this.setState({
            longAddressValue: curVal,
            requiredError: this.state.required ? hasEmptyValues : false
        });
    };

    renderAddressInput = (label, value, isShort = false) => {
        return (
            <label className="text-label address-label">
                <span
                    className="address-input-label"
                    style={{ color: this.props.textColor }}
                >{ label }</span>
                <div className="default-input-wrapper">
                    <input
                        className="default-input"
                        value={isShort ? value : this.state.longAddressValue[label]}
                        onChange={isShort? this.setShortAddressValue : (e) => this.setLongAddressValue(label, e)}
                        placeholder="Type..."
                        type="text"
                    />
                </div>
            </label>
        )
    }

    render() {
        const { textColor, isResultInput } = this.props;
        return (
            <>
                <AppInputWrapper
                    labelFontSize="18px"
                    label={this.state.label}
                    color={textColor}
                    required={this.state.required}
                    requiredError={this.state.requiredError}
                >
                    {
                        this.state.addressType === ADDRESS_TYPES.SHORT ?

                            <div className="short-address">
                                { this.renderAddressInput('Address', this.state.shortAddressValue, true) }
                            </div>
                            :
                            <div className="long-address">
                                { this.renderAddressInput('Address line 1') }

                                { this.renderAddressInput('Address line 2') }


                                <div className="text-row">
                                    { this.renderAddressInput('Town/City') }

                                    { this.renderAddressInput('Postcode/Zip Code') }
                                </div>

                                { this.renderAddressInput('Country') }
                            </div>
                    }
                </AppInputWrapper>
                {
                    !isResultInput &&
                    <AppCollapsible>
                        <div className="settings-container">
                            <label>
                                <select value={this.state.addressType} onChange={this.setAddressType}>
                                    <option>{ ADDRESS_TYPES.SHORT }</option>
                                    <option>{ ADDRESS_TYPES.LONG }</option>
                                </select>
                                address type
                            </label>

                            <label>
                                <input value={this.state.label} onChange={this.setLabel} type="text"/>
                                label
                            </label>

                            <label>
                                <input checked={this.state.required} onChange={this.setRequired} type="checkbox"/>
                                required
                            </label>
                        </div>
                    </AppCollapsible>
                }

            </>
        );
    }
}

export default connect(
    () => ({}),
    {
        editInputWithProps
    }
)(Address);